<div class="flex flex-col h-full w-full">
  @if (loading) {
    <div class="flex flex-col flex-1 h-full justify-center items-center py-16">
      <div class="flex flex-row items-center gap-2">
        <fa-icon [icon]="faSpinnerThird" class="text-gray-500 animate-spin text-svg-16"></fa-icon>
        <span class="text-sm font-medium text-gray-500">Prüfablauf wird geladen...</span>
      </div>
    </div>
  } @else {
  <!-- Header -->
  <app-page-header>
    <div class="flex items-center gap-3 flex-1 min-w-0">
      <button (click)="goBack()" class="flex items-center justify-center w-8 h-8 rounded-lg hover:bg-gray-100">
        <fa-icon [icon]="faChevronLeft" class="text-sm text-gray-500"></fa-icon>
      </button>
      <span class="text-xl font-medium text-gray-900 truncate">
        Prüflauf - {{ currentStepTitle }}
      </span>
    </div>
    <div class="flex items-center gap-4">
      <!-- Adminfunktion: die Kopie gehört dem Adminbereich, nicht diesem Projekt. -->
      @if (adminGlobal) {
        <app-admin-badge></app-admin-badge>
      }
      @if (currentStep === 1) {
        <bic-button (onClick)="navigateToRuleManagement()" buttonType="white">
          myChecks
        </bic-button>
      }
<!--      <bic-button (onClick)="testWorkflow()" [loading]="testing" buttonType="white">
        <fa-icon [icon]="faPlay" class="text-xs mr-1"></fa-icon>
        Test
      </bic-button>-->
      <!-- Admin in Beta: Entwurf verwerfen / als neue Version einreichen. Eingereicht wird der
           gespeicherte Stand, deshalb erst nach dem Speichern. -->
      @if (adminDraft && draftId) {
        <bic-button (onClick)="requestDiscard()" [disabled]="saving" buttonType="white">
          <fa-icon [icon]="faTrash" iconLeft></fa-icon>
          Entwurf verwerfen
        </bic-button>
        <bic-button (onClick)="requestSubmission()" [disabled]="isDirty || saving" buttonType="white"
                    [tooltip]="isDirty ? 'Bitte zuerst speichern' : 'Entwurf im Admin Center zur Freigabe einreichen'"
                    tooltipDirection="bottom">
          <fa-icon [icon]="faPaperPlaneTop" iconLeft></fa-icon>
          In Beta bereitstellen
        </bic-button>
      }
      @if (adminReadOnly) {
        <bic-button (onClick)="goBack()" buttonType="primary">
          <fa-icon iconLeft [icon]="faChevronLeft"></fa-icon>
          Zurück
        </bic-button>
      } @else {
        <bic-button (onClick)="isDirty ? saveWorkflow() : goBack()" [loading]="saving" buttonType="primary">
          <fa-icon iconLeft [icon]="isDirty ? faFloppyDisk : faChevronLeft"></fa-icon>
          {{ isDirty ? 'Speichern' : 'Zurück' }}
        </bic-button>
      }
    </div>
  </app-page-header>

  <!-- Content area -->
      <div class="flex-1 min-h-0 overflow-y-auto p-6 flex flex-col">
        <!-- Stepper -->
        <my-checks-builder-stepper
          (stepChange)="onStepChange($event)"
          [currentStep]="currentStep"
          [invalidSteps]="showValidation ? invalidSteps : []">
        </my-checks-builder-stepper>

    <!-- Admin: worauf sich Änderungen auswirken -->
    @if (adminReadOnly) {
      <div class="mt-4 flex flex-row items-start gap-2 p-3 rounded-lg bg-blue-50 border border-blue-100">
        <fa-icon [icon]="faCircleInfo" class="text-blue-900 text-sm shrink-0 mt-0.5"></fa-icon>
        <span class="text-sm text-blue-900">
          Nur lesend: Änderungen erfolgen in Beta und werden über das Admin Center freigegeben.
        </span>
      </div>
    } @else if (adminDraft) {
      <div class="mt-4 flex flex-row items-start gap-2 p-3 rounded-lg bg-blue-50 border border-blue-100">
        <fa-icon [icon]="faCircleInfo" class="text-blue-900 text-sm shrink-0 mt-0.5"></fa-icon>
        <span class="text-sm text-blue-900">
          @if (draftId) {
            Sie bearbeiten einen Entwurf.
          } @else {
            Sie sehen die installierte Fassung. Beim Speichern entsteht ein Entwurf.
          }
          Empfänger sehen weiter die bereitgestellte Fassung, bis der Entwurf mit „In Beta
          bereitstellen“ übernommen wird.
        </span>
      </div>
    }

    <!-- Hinweis: fehlende Pflichtangaben (nicht-blockierend; Check wurde als Entwurf gespeichert) -->
    @if (showValidation && missingFields.length > 0) {
      <div class="mt-4 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
        <p class="text-sm font-medium text-yellow-800 mb-1">
          Dieser Prüfablauf ist noch unvollständig und wurde als Entwurf gespeichert. Bitte ergänze:
        </p>
        <ul class="list-disc list-inside space-y-1">
          @for (field of missingFields; track field.field) {
            <li class="text-sm text-yellow-800">{{ field.message }}</li>
          }
        </ul>
      </div>
    }

        <!-- Step content -->
        <!-- Live: schreibgeschützt – die Schritte bleiben sichtbar, sind aber nicht bedienbar. -->
        <div [attr.inert]="adminReadOnly ? '' : null" class="mt-6 flex-1 min-h-0 flex flex-col">
          @switch (currentStep) {
            @case (0) {
              <my-checks-builder-start-step
                (openSchedule)="openSchedulePopup()"
                (stateChange)="onStateChange($event)"
                [scheduleSavesFirst]="isDirty"
                [scheduleSummary]="scheduleSummary"
                [scheduleUnavailableReason]="scheduleUnavailableReason"
                [showErrors]="showValidation"
                [state]="state">
              </my-checks-builder-start-step>
            }
            @case (1) {
              <my-checks-builder-rule-step
                (stateChange)="onStateChange($event)"
                [projectId]="projectId"
                [showErrors]="showValidation"
                [state]="state"
                class="flex-1 min-h-0 flex flex-col">
              </my-checks-builder-rule-step>
            }
            @case (2) {
              <my-checks-builder-file-step
                (stateChange)="onStateChange($event)"
                [projectId]="projectId"
                [showErrors]="showValidation"
                [state]="state">
              </my-checks-builder-file-step>
            }
            @case (3) {
              <my-checks-builder-report-step
                (stateChange)="onStateChange($event)"
                [projectId]="projectId"
                [state]="state">
              </my-checks-builder-report-step>
            }
          }
        </div>
      </div>
  }
</div>

<!-- Entwurf verwerfen (Bestätigung) -->
@if (confirmDiscard) {
  <bic-popup (close)="cancelDiscard()" [customClass]="'w-[560px] h-fit relative'" [hasBackdrop]="true"
             title="Entwurf verwerfen?">
    <app-admin-badge [floating]="true"></app-admin-badge>
    <div bicPopupContent class="flex flex-col">
      <span class="font-normal">
        Alle Änderungen dieses Entwurfs gehen verloren. Die installierte Fassung und ihre Empfänger
        bleiben unverändert. Bereits bereitgestellte Fassungen sind davon nicht betroffen.
      </span>
    </div>
    <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">
      <bic-button (onClick)="cancelDiscard()" [disabled]="discarding" buttonType="white">Abbrechen</bic-button>
      <bic-button (onClick)="discardDraft()" [loading]="discarding" buttonType="primary">Verwerfen</bic-button>
    </div>
  </bic-popup>
}

<!-- Entwurf als neue Version des Katalog-Eintrags einreichen -->
@if (submissionOpen && draftId) {
  <app-catalog-submission-prompt
    (closed)="closeSubmission()"
    (submitted)="closeSubmission()"
    [itemName]="definition!.name ?? ''"
    [itemType]="'WORKFLOW'"
    [newVersion]="true"
    [sourceId]="draftId">
  </app-catalog-submission-prompt>
}

<!-- Zeitplan des Prüflaufs im aktuellen Projekt (gilt für den gespeicherten Stand) -->
@if (schedulePopupOpen && definition?.id && projectId) {
  <app-check-run-schedule-popup
    (closed)="closeSchedulePopup()"
    (deleted)="onScheduleDeleted()"
    (saved)="onScheduleSaved($event)"
    [definitionId]="definition!.id!"
    [definitionName]="definition!.name ?? state.name"
    [projectId]="projectId!"
    [schedule]="schedule">
  </app-check-run-schedule-popup>
}
